import { z } from "zod";

const walletBaseSchema = z
	.object({
		walletName: z.string().min(1, "Wallet Name is required"),
		companyName: z.string().min(1, "Company Name is required"),
		selectedProducts: z.array(z.enum(["Deposit", "Withdraw"])).default([]),
		custodialType: z.string().optional(),
		chain: z.string().optional(),
		asset: z.string().optional(),
		contactName: z.string().optional(),
		contactEmail: z.string().optional(),
		contactPhone: z.string().optional(),
		contactRole: z.string().optional(),
		slackChannel: z.string().optional(),
		homeDomain: z.string().optional(),
		fundingAddress: z.string().optional(),
		conductsKYC: z.union([z.boolean(), z.string()]).optional(),
		mau: z.string().optional(),
		licenses: z.string().optional(),
		countryOfIncorporation: z.string().optional(),
		selectedWishlist: z.array(z.string()).optional(),
		selectedMarkets: z.array(z.string()).optional(),
		primaryContactEmail: z.string().optional(),
		agentId: z.string().optional(),
		mainOfficeId: z.string().optional(),
		// Existing partner fields (admin-only)
		isExistingPartner: z.boolean().optional(),
		integrationStatus: z.string().optional(),
		onboardingStatus: z.string().optional(),
	})
	.superRefine((data, ctx) => {
		if (!data.isExistingPartner && data.selectedProducts.length === 0) {
			ctx.addIssue({
				code: "custom",
				message: "At least one Product is required",
				path: ["selectedProducts"],
			});
		}
	});

export const addWalletSchema = walletBaseSchema;

export type AddWalletFormData = z.infer<typeof addWalletSchema>;

export const editWalletSchema = addWalletSchema;

export type EditWalletFormData = z.infer<typeof editWalletSchema>;
